module.exports = __webpack_public_path__ + "static/media/[钻戒]@2x.ed0da20b.png";